import React from 'react'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const Img = styled.img`
  @media (max-width: 575px) {
    width: 80px;
  }
`

const P = styled.p`
  @media (max-width: 410px) {
    font-size: 14px;
  }
  @mdia (max-width: 380px) {
    font-size: 12x;
  }
`

const H5 = styled.h5`
  @media (max-width: 410px) {
    font-size: 18px;
  }
  @mdia (max-width: 380px) {
    font-size: 16x;
  }
`

const H6 = styled.h6`
  @media (max-width: 410px) {
    font-size: 14px;
  }
  @mdia (max-width: 380px) {
    font-size: 12x;
  }
`

export const Footer = () => {
  const company = [
    { path: '/company/greetings', label: '인사말' },
    { path: '/company/history', label: '연혁' },
    { path: '/company/license', label: '면허보유현황' },
    { path: '/company/vision', label: '비전 및 미션' },
    { path: '/company/map', label: '찾아오시는 길' },
  ]

  const business = [
    { path: '/business/facility', label: '시설개요' },
    { path: '/business/distribution', label: '물류 시설 현황' },
    { path: '/business/equipment', label: '장비 현황' },
  ]

  return (
    <footer className="bg-indigo w-100 py-5">
      <Container className="d-lg-flex justify-content-between">
        {/* 회사 정보 */}
        <section
          id="footer-company-info"
          className=" flex-grow-1 flex-grow-md-0"
        >
          <div className="d-flex mb-2">
            <Img
              className="mb-0 me-4"
              src="/logo/logo-white.png"
              alt="서진로지텍"
              width={100}
            />
            <h5 className="mb-0 fw-medium d-flex align-items-center">
              ㈜ 서진로지텍
            </h5>
          </div>
          <div className="footer-text-color">
            <div className="d-sm-flex">
              <P>사업자등록번호: 416-81-99541</P>
              <div className="px-4 d-none d-sm-block">|</div>
              <P>대표자: 양희경</P>
            </div>
            <P>
              전화: 061-795-0096
              <span className="px-3" />
              팩스: 070-7610-9220
            </P>
            <div id="divider" />
            <P>
              전남 광양시 항만2로 114 (황길동 1413) 서진로지텍
              <br />
              (우편번호: 57771)
            </P>
          </div>
        </section>
        <nav
          id="footerNav"
          className="d-flex justify-content-between mt-5 mt-lg-0"
          style={{ maxWidth: '500px' }}
        >
          <div className="d-flex flex-column">
            <Link to="/company/greetings" className="mb-4 text-decoration-none">
              <H5 style={{ color: 'white' }}>회사소개</H5>
            </Link>
            {company.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`my-1 text-decoration-none`}
              >
                <H6 style={{ color: '#6B7287' }}>{item.label}</H6>
              </Link>
            ))}
          </div>
          <div className="d-flex flex-column ms-0 ms-sm-5">
            <Link to="/business/facility" className="mb-4 text-decoration-none">
              <H5 style={{ color: 'white' }}>사업소개</H5>
            </Link>
            {business.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`my-1 text-decoration-none`}
              >
                <H6 style={{ color: '#6B7287' }}>{item.label}</H6>
              </Link>
            ))}
          </div>
          <div className="d-flex flex-column ms-0 ms-sm-5">
            <Link to="/gallery/gallery" className="mb-4 text-decoration-none">
              <H5 style={{ color: 'white' }}>갤러리</H5>
            </Link>
          </div>
        </nav>
      </Container>
    </footer>
  )
}
